import { SET_LOADER } from "../actions/ui.action";

const initState = {
  loading: false,
};

export const uiReducer = (ui = initState, action: any) => {
  switch (true) {
    case action.type.includes(SET_LOADER):
      return { ...ui, loading: action.payload };

    default:
      return ui;
  }
};
